module.exports = __webpack_public_path__ + "static/img/operateHuhui.9fd84c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateHuhui.png
// module id = kySJ
// module chunks = 1